import { render, staticRenderFns } from "./FormEditFranchiseQuickFacts.vue?vue&type=template&id=db10eb84&scoped=true&"
import script from "./FormEditFranchiseQuickFacts.vue?vue&type=script&lang=js&"
export * from "./FormEditFranchiseQuickFacts.vue?vue&type=script&lang=js&"
import style0 from "./FormEditFranchiseQuickFacts.vue?vue&type=style&index=0&id=db10eb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db10eb84",
  null
  
)

export default component.exports